import * as logger from 'utilities/loggerx';

export type ClipVideoClip = [number, number];

// Sanitize the clip range to make sure we get a valid clip for the video player
export const sanitizeClip = (
  // eslint-disable-next-line
  video: any,
  clip: ClipVideoClip
): [number, number] => {
  if (!video) {
    return [0, 0];
  }

  const clipStart = Math.max(clip?.[0] ?? 0, 0);
  let clipEnd = clip?.[1] ?? video.videoProperties?.duration;

  if (clipStart > clipEnd) {
    logger.error(new Error('clip end is before clip start'), {
      clip,
      videoId: video.id,
    });

    clipEnd = video.videoProperties?.duration ?? 0;
  }

  return [Math.round(clipStart), Math.round(clipEnd)];
};
